import { getComponentMethodDeclarations } from '../../renderer/utils';
const getMethodSchema = function () {
  var _this$container, _this$designer, _getComponentMethodDe;
  const currentParams = (_this$container = this.container) === null || _this$container === void 0 || (_this$container = _this$container.stub.parent) === null || _this$container === void 0 ? void 0 : _this$container.value;
  if (!currentParams) return null;
  const {
    selector,
    methodName
  } = currentParams;
  if (!selector || !methodName) return null;
  const queryResult = (_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.renderer) === null || _this$designer === void 0 ? void 0 : _this$designer.ucQuerySelector(selector, this.designer.compPath);
  if (!queryResult) return null;
  const {
    renderer,
    compPath
  } = queryResult;
  return (_getComponentMethodDe = getComponentMethodDeclarations(renderer, compPath)) === null || _getComponentMethodDe === void 0 ? void 0 : _getComponentMethodDe.find(x => x.id === methodName);
};
const paramsSchema = {
  type: 'object',
  fields: [{
    id: 'selector',
    title: '哪一个组件',
    type: 'string',
    ui: {
      type: 'compSelectorInput',
      props: {
        placeholder: '(留空则为自己)'
      }
    }
  }, {
    id: 'methodName',
    type: 'string',
    title: '调用它的什么方法',
    ui: {
      type: 'uicore:ComponentMethodNameInput'
    }
  }, {
    id: 'arguments',
    type: 'array',
    items: {
      type: 'string'
    },
    title: '参数',
    'uc:allowInterop': false,
    ui: {
      type: 'uicore:MethodArgumentsInput',
      props: {
        getMethodSchema
      }
    }
  }]
};
export const invokeComponentMethodAtom = {
  id: 'uicore:invokeComponentMethodAtom',
  name: '组件联动',
  desc: '调用指定组件的能力/方法。\n\n配置参数时，请直接输入表达式，无需加双花括号！',
  returnValue: '被调用组件方法的返回值',
  category: '逻辑',
  paramsSchema: paramsSchema,
  // paramsFormComponents: 迁移到 designerComponents 了,
  execute: async (ctx, params) => {
    var _ctx$renderer;
    const {
      selector,
      methodName,
      arguments: args = []
    } = params;
    const req = (_ctx$renderer = ctx.renderer) === null || _ctx$renderer === void 0 ? void 0 : _ctx$renderer.ucQuerySelector(selector, ctx.compPath);
    const compInstance = req === null || req === void 0 ? void 0 : req.renderer.getRefByPath(req.compPath);
    if (!compInstance) {
      throw new Error(`无法联动组件 ${selector}，找不到联动目标`);
    }
    const func = compInstance[methodName];
    if (typeof func !== 'function') {
      throw new Error(`组件 ${selector} 不存在联动方法 ${methodName}`);
    }
    const finalArgs = args.map(expr => expr ? ctx.tryEval(expr) : undefined);
    // eslint-disable-next-line prefer-spread
    const ans = await func.apply(compInstance, finalArgs);
    return ans;
  },
  getDisplayName(step) {
    const {
      selector,
      methodName
    } = step.params;
    if (!selector && !methodName) return undefined;
    return `调用组件 ${methodName} 方法（${selector || '当前组件'}）`;
  }
};